import { render, staticRenderFns } from "./ConsultantActivityItem.vue?vue&type=template&id=6d589673&"
import script from "./ConsultantActivityItem.vue?vue&type=script&lang=ts&"
export * from "./ConsultantActivityItem.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultantActivityItem.vue?vue&type=style&index=0&id=6d589673&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports